import React, { useEffect, useState } from 'react';
//Hooks
import { useParams } from 'react-router-dom';

//Componentes
import PostMethods from '../PostMethods/PostMethods';
import SectionTitle from '../../_ui/SectionTitle/SectionTitle';

import { getThisPost } from '../../../actions/posts.action';

const AddPostScreen = () => {
    let params = useParams();

    const [selectedPost, setSelectedPost] = useState({ title: 'Sin título', subtitle: '', slugArray: [], content: { slider: [], image: [], text: [], video: [], gallery: [] } });

    useEffect(() => {
        findCurrentPost(params.postID);
    }, [params.postID]);

    //Post Methods
    const findCurrentPost = async (id) => {
        const currentPost = await getThisPost(id);
        setSelectedPost(currentPost);
    };

    return (
        <section id="add-posts-screen">
            <SectionTitle
                image={ process.env.REACT_APP_POST_IMAGE }
                title="Nueva entrada"
                instructions="Estás añadiendo una entrada nueva al blog :)"
            />

            <PostMethods selectedPost={ selectedPost } setSelectedPost={ setSelectedPost } />
        </section>

    );
};

export default AddPostScreen;
